// Screen `setup` — design/screens/SetupWizard.dc.html — owner: shell-nav (wave 2; S11 before).
// A `?token=` link (DR_SETUP_TOKEN) is moved out of the address into this tab's storage at once, so
// the token does not stay in the history or reach proxy logs again.
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { z } from 'zod';
import { SetupPage, rememberSetupToken, rememberedSetupToken } from '../../features/ops/setup/SetupPage';

export const Route = createFileRoute('/_public/setup')({
  validateSearch: z.object({ token: z.string().max(512).optional() }),
  component: SetupRoute,
});

function SetupRoute() {
  const { token: fromUrl } = Route.useSearch();
  const navigate = useNavigate();
  const [token] = useState(() => {
    if (fromUrl) rememberSetupToken(fromUrl);
    return fromUrl ?? rememberedSetupToken();
  });
  useEffect(() => {
    if (fromUrl) void navigate({ to: '/setup', search: {}, replace: true });
  }, [fromUrl, navigate]);
  return <SetupPage token={token} />;
}
